import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { Observable } from 'rxjs';
import { ApiConstants } from '../constants/api-url.constant';
import { SessionVariable } from '../enum/session-variable';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private storageService: LocalStorageService,
    private http: HttpClient, private toasterService: MessageService
  ) { }


  login(request: any): Observable<any> {
    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic YnJvd3NlcjpzZWNyZXQ=',
      requestFor: 'consumer',
    });

    const body = new URLSearchParams();
    body.set('username', request?.username);
    body.set('password', request?.password);
    body.set('grant_type', 'password');
    body.set('scope', 'ui');

    return this.http.post<any>(ApiConstants.OAUTH_TOKEN, body.toString(), { headers: header })
  }

  refreshToken(): Observable<any> {
    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic YnJvd3NlcjpzZWNyZXQ=',
      refreshtoken: 'true',
    });
    const refresh_token: any =
      this.storageService.getItem(SessionVariable.REFRESHT_TOKEN_KEY) || null;
    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('refresh_token', refresh_token);
    return this.http.post(ApiConstants.OAUTH_TOKEN, body.toString(), {
      headers: header,
    });
  }

  signInOrUpInit(request: any): Observable<any> {
    return this.http.post(ApiConstants.SIGNUP_INIT, request);
  }

  verfiyOTP(request: any): Observable<any> {
    return this.http.post(ApiConstants.VERIFY_OTP, request, { responseType: 'text' });
  }

  resendOTP(request: any): Observable<any> {
    return this.http.post(ApiConstants.RESEND_OTP, request);
  }

  verifyNationalId(request: any): Observable<any> {
    return this.http.post(ApiConstants.NATIONAL_ID, request);
  }
  cnetAuthentication(request: any): Observable<any> {
    return this.http.post(ApiConstants.CNET_AUTHENTICATION, request);
  }

  cnetAuthenticationStatus(civilId: any, referenceNo: any, UserId?: any): Observable<any> {
    let url = ApiConstants.CNET_AUTHENTICATION_STATUS(civilId, referenceNo);
    
    if (UserId !== undefined) {
      url = `${url}&userId=${UserId}`;
    }
  
    return this.http.get(url);
  }
  

  cnetAuthenticationToken(requestId: any, userId: any): Observable<any> {
    return this.http.get(ApiConstants.CNET_AUTHENTICATION_TOKEN(requestId, userId));
  }

  requestStatus(request: any): Observable<any> {
    return this.http.post(ApiConstants.REQUEST_STATUS, request);
  }

  customerInfo(request: any): Observable<any> {
    return this.http.post(ApiConstants.CUSTOMER_INFO, request);
  }

  getCreditCard(): Observable<any> {
    return this.http.get(ApiConstants.CREDIT_CARD);
  }

  saveCreditCard(request: any): Observable<any> {
    return this.http.post(ApiConstants.CREDIT_CARD, request);
  }

  orderProcess(request: any): Observable<any> {
    return this.http.post(ApiConstants.ORDER_PROCESS, request);
  }

  payInstallmentOnKnet(request: any): Observable<any> {
    return this.http.post(ApiConstants.INSTALLMENT_PAY_KNET, request);
  }

  payByApplePay(request: any): Observable<any> {
    return this.http.post(ApiConstants.INSTALLMENT_PAY_APPLE, request);
  }

  retrieveCharge(chargeId: string, paymentType: string): Observable<any> {

    const API_URL = paymentType == 'knet' ? ApiConstants.PAYMENT_STATUS(chargeId) : ApiConstants.RETRIEVE_CHARGE(chargeId);

    return this.http.get(API_URL);
  }

  showMessage(severityType: string, toastMessage: string) {
    this.toasterService.clear();
    this.toasterService.add({ severity: severityType, detail: toastMessage });
  }

  getUserProfile(): Observable<any> {
    return this.http.get(ApiConstants.GET_USER_PROFILE);
  }

}